import _ from 'lodash';

import { ILevelDomainData } from 'src/app/infrastructure/models/level-domain-data';
import { IProjectCategoryForm } from './project-category-form';
import { IProjectCategoryDto, projectCategoryDto } from 'src/assets/common/models/project-category-dto.g';

export const projectCategoryData = {
    guid: 'guid',
    nr: 'nr',
    description: 'description',
    deleted: 'deleted',   
    inactive: 'inactive', 
} as const;

export type TProjectCategoryData = (typeof projectCategoryData)[keyof typeof projectCategoryData];

export interface IProjectCategoryData extends ILevelDomainData {
    [projectCategoryData.guid]: string;
    [projectCategoryData.nr]: number | null;
    [projectCategoryData.description]: string | null;
    [projectCategoryData.deleted]: boolean;
    [projectCategoryData.inactive]: boolean;
}

export class ProjectCategoryData
    implements IProjectCategoryData, ILevelDomainData
{
    [projectCategoryData.guid]!: string;
    [projectCategoryData.nr]: number | null = null;
    [projectCategoryData.description]: string | null = null;
    [projectCategoryData.deleted]!: boolean;
    [projectCategoryData.inactive]!: boolean;

    protected constructor(modelDto?: IProjectCategoryDto | null);
    protected constructor(modelData: IProjectCategoryData, modelForm: IProjectCategoryForm);
    protected constructor(value?: IProjectCategoryDto | IProjectCategoryData | null, modelForm?: IProjectCategoryForm) {
        if (!!modelForm) {
            const _modelData = value as IProjectCategoryData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IProjectCategoryDto;

            this[projectCategoryData.guid] = _modelDto?.[projectCategoryDto.guid]!;
            this[projectCategoryData.nr] = _modelDto?.[projectCategoryDto.nr];
            this[projectCategoryData.description] = _modelDto?.[projectCategoryDto.description];
            this[projectCategoryData.deleted] = _modelDto?.[projectCategoryDto.deleted]!
            this[projectCategoryData.deleted] = _modelDto?.[projectCategoryDto.deleted]!;
        }
    }
        
    static create(modelDto?: IProjectCategoryDto | null): IProjectCategoryData | null
    static create(modelData: IProjectCategoryData, modelForm: IProjectCategoryForm): IProjectCategoryData | null
    static create(value?: IProjectCategoryDto | IProjectCategoryData | null, modelForm?: IProjectCategoryForm): IProjectCategoryData | null {

        if (!!modelForm) {
            const _modelData = value as IProjectCategoryData;
            return new ProjectCategoryData(_modelData, modelForm);
        } else {
            const _modelDto = value as IProjectCategoryDto;
            return _modelDto ? new ProjectCategoryData(_modelDto) : null;
        }
    }
}
